// =============================================
// File: src/services/productService.js
// =============================================

import axiosInstance from './axiosConfig';

const productService = {
  // Get all products with pagination and filters
  getProducts: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/products', { params });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get single product by ID
  getProductById: async (id) => {
    try {
      const response = await axiosInstance.get(`/products/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Create new product
  createProduct: async (productData) => {
    try {
      const response = await axiosInstance.post('/products', productData,
        {
           headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update product
  updateProduct: async (id, productData) => {
    try {
      const response = await axiosInstance.put(`/products/${id}`, productData,
         {
           headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Delete product
  deleteProduct: async (id) => {
    try {
      const response = await axiosInstance.delete(`/products/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Bulk delete products
  bulkDeleteProducts: async (ids) => {
    try {
      const response = await axiosInstance.post('/products/bulk-delete', { ids });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Upload product image
  uploadProductImage: async (id, formData) => {
    try {
      const response = await axiosInstance.post(`/products/${id}/upload-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update product stock
  updateStock: async (id, quantity) => {
    try {
      const response = await axiosInstance.patch(`/products/${id}/stock`, { quantity });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get product images gallery
  getProductGallery: async () => {
    try {
      const response = await axiosInstance.get('/products/gallery');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Search products
  searchProducts: async (query) => {
    try {
      const response = await axiosInstance.get('/products/search', { 
        params: { q: query } 
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default productService;